import { render, staticRenderFns } from "./NominationDashboardCards.vue?vue&type=template&id=fe98bc74&scoped=true"
import script from "./NominationDashboardCards.vue?vue&type=script&lang=js"
export * from "./NominationDashboardCards.vue?vue&type=script&lang=js"
import style0 from "./NominationDashboardCards.vue?vue&type=style&index=0&id=fe98bc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe98bc74",
  null
  
)

export default component.exports